import { useCallback } from 'react'

import { TasksValueObjectsTaskStatusEnum } from 'generated/resources/datatable.graphql'
import { UpdateTaskStatusesDocument } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type UpdateTaskStatusesParams = {
  taskIds: string[]
  status: TasksValueObjectsTaskStatusEnum
}

const optimisticResponse = ({ taskIds, status }: UpdateTaskStatusesParams) => ({
  __typename: 'root_mutation' as const,
  tasksMutations: {
    __typename: 'tasksMutations' as const,
    bulkMarkAsTasksInboxTask: {
      __typename: 'BulkMarkAsTasksInboxTaskPayload' as const,
      errors: [],
      inboxTasks: taskIds.map((taskId) => ({
        __typename: 'TasksInboxTask' as const,
        id: taskId,
        status,
        completedAt: new Date().toISOString(),
      })),
    },
  },
})

export const useUpdateTaskStatuses = () => {
  const [updateTasks] = useMutation(UpdateTaskStatusesDocument, {
    extractorFn: (data) => data.tasksMutations.bulkMarkAsTasksInboxTask,
    optimisticResponse,
  })

  const updateTaskStatuses = useCallback(
    async ({ taskIds, status }: UpdateTaskStatusesParams) => {
      await updateTasks({
        variables: {
          taskIds,
          status,
        },
      })
    },
    [updateTasks]
  )

  return updateTaskStatuses
}
